import { render, staticRenderFns } from "./RedcollegeCard.vue?vue&type=template&id=55abdbb1&scoped=true&"
import script from "./RedcollegeCard.vue?vue&type=script&lang=js&"
export * from "./RedcollegeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abdbb1",
  null
  
)

export default component.exports